export interface RecentPurchase {
  firstName: string
  city: string
  country: string
  /** ISO 3166-1 alpha-2 code, used for the flag (e.g. "gb", "us") */
  countryCode: string
  minutesAgo: number
}

/**
 * Real recent orders from checkout. Populate this from your order data
 * (e.g. a webhook or export from the checkout provider). These are the
 * notifications shown on the published page.
 */
export const recentPurchases: RecentPurchase[] = []

/**
 * Layout entries used only inside the editor preview so the design can be
 * reviewed before real order data is connected. Never shown on the live page.
 */
export const previewPurchases: RecentPurchase[] = [
  { firstName: 'James', city: 'Leeds', country: 'UK', countryCode: 'gb', minutesAgo: 10 },
  { firstName: 'Michael', city: 'Austin', country: 'USA', countryCode: 'us', minutesAgo: 3 },
  { firstName: 'Ryan', city: 'Toronto', country: 'Canada', countryCode: 'ca', minutesAgo: 5 },
  { firstName: 'Daniel', city: 'Manchester', country: 'UK', countryCode: 'gb', minutesAgo: 8 },
  { firstName: 'Liam', city: 'Melbourne', country: 'Australia', countryCode: 'au', minutesAgo: 12 },
  { firstName: 'Ethan', city: 'Dublin', country: 'Ireland', countryCode: 'ie', minutesAgo: 15 },
  { firstName: 'Noah', city: 'Vancouver', country: 'Canada', countryCode: 'ca', minutesAgo: 5 },
  { firstName: 'Jacob', city: 'Chicago', country: 'USA', countryCode: 'us', minutesAgo: 10 },
]
